// Discover's calls (W2), on the one client.
//   fetchFeed({ take, ignore, filters, withTotal })  GET /feed
//   joinSession(name, me)                             POST /join
//   createSession(body)                               POST /session
//   sessionExists(name)                               GET /session (404: free)
//
// GET /feed takes the app's parameters (FeedFilters.toQuery: bpm_min,
// bpm_max, key, scale, tags, live_only) plus with_total=1 on the first
// request after a filter change (B3). With with_total the server answers
// { sessions, total, live_total }; otherwise, and on a server without B3,
// a bare array (which ignores the filters: the deck applies them itself).
import { apiGet, apiPost } from "./client.js";
import { toQuery } from "../../kit/feedFilters.js";

export function feedQuery({ take = 20, ignore = [], filters = null, withTotal = false } = {}) {
  const q = { take, ...toQuery(filters) };
  if (ignore && ignore.length) q.ignore = ignore.join(",");
  if (withTotal) q.with_total = 1;
  return q;
}

// { sessions, total, liveTotal, shaped }: `shaped` is true when the server
// sent the B3 object (it filtered and counted).
export function readFeed(res) {
  if (Array.isArray(res)) return { sessions: res, total: null, liveTotal: null, shaped: false };
  if (res && Array.isArray(res.sessions)) {
    const n = (v) => (Number.isFinite(Number(v)) && v !== null && v !== "" ? Number(v) : null);
    return { sessions: res.sessions, total: n(res.total), liveTotal: n(res.live_total), shaped: true };
  }
  return { sessions: [], total: null, liveTotal: null, shaped: false };
}

export async function fetchFeed(opts = {}) {
  return readFeed(await apiGet("/feed", feedQuery(opts)));
}

export function joinSession(name, me) {
  return apiPost("/join", { username: me, session_name: name });
}

export function createSession(body) {
  return apiPost("/session", body, { query: { session_name: body.session_name } });
}

// GET /session?session_name=: a 404 means the name is free.
export async function sessionExists(name) {
  try {
    await apiGet("/session", { session_name: name });
    return true;
  } catch (e) {
    if (e && e.status === 404) return false;
    // A private session someone else holds (403) is taken too.
    if (e && e.status === 403) return true;
    throw e;
  }
}

export function inviteToSession(sessionName, username) {
  return apiPost("/invitations", { session_name: sessionName, invitee_username: username });
}

export default { fetchFeed, feedQuery, readFeed, joinSession, createSession, sessionExists, inviteToSession };
